import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import DeviceInfo from '../../../../api/DeviceInfo';
import { EVENT_TYPES } from '../../../../lib/analytics/constants';
import Logger from '../../../../lib/analytics/logger';
import Screens from '../../../../screens';
import utils from '../../../../utils';
import gameVersion from '../../../../utils/gameVersion';
import ERROR_CODE from '../../../../utils/errorCodes';
import navigation from '../../../../utils/navigation/navigation';
import { setRestartSession } from '../../../actions/app';
import { clearToken } from '../../../actions/auth';
import store from '../../../store';
import { validRestartSession } from './validations';
export var dispatchRestartSession = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(error) {
    var authToken, restartToken, _require, postRestartSession;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!validRestartSession(error)) {
              _context.next = 25;
              break;
            }

            store.dispatch(setRestartSession(true));
            authToken = store.getState().token.token;
            restartToken = store.getState().restart.token;
            _require = require('../../../query/restartSession'), postRestartSession = _require.postRestartSession;

            if (!authToken) {
              _context.next = 22;
              break;
            }

            _context.prev = 6;
            _context.next = 9;
            return store.dispatch(postRestartSession.initiate({
              Authentication: authToken,
              restarttoken: restartToken
            })).unwrap();

          case 9:
            navigation.navigate(Screens.Lobby);
            _context.next = 17;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](6);
            store.dispatch(clearToken());
            navigation.navigate(Screens.SessionExpired);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              body: JSON.stringify(_context.t0),
              code: ERROR_CODE.RESTART_SESSION_LOGIN_ERROR_HANDLER
            });

          case 17:
            _context.prev = 17;
            store.dispatch(setRestartSession(false));
            return _context.finish(17);

          case 20:
            _context.next = 25;
            break;

          case 22:
            store.dispatch(clearToken());
            store.dispatch(setRestartSession(false));
            navigation.navigate(Screens.Start);

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 12, 17, 20]]);
  }));

  return function dispatchRestartSession(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var getRequestData = function getRequestData(data) {
  var _data, _data2, _data3;

  if (!data) return null;
  if ((_data = data) === null || _data === void 0 ? void 0 : _data.raw) return JSON.stringify(data.body);
  if ((_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.isBinary) return data.body;
  data = ((_data3 = data) === null || _data3 === void 0 ? void 0 : _data3.body) || data;

  if (utils.isReactNative()) {
    data = _objectSpread({
      uid: DeviceInfo.getUID(),
      device: DeviceInfo.getDevice(),
      sysver: DeviceInfo.getSysVer(),
      bundlever: gameVersion(),
      bundleid: DeviceInfo.getBundleId(),
      uuid: DeviceInfo.getUID()
    }, data);
  }

  var formBody = [];

  for (var property in data) {
    var encodedValue = '';

    if (typeof data[property] === 'object') {
      encodedValue = encodeURIComponent(JSON.stringify(data[property]));
    } else {
      encodedValue = encodeURIComponent(data[property]);
    }

    var encodedKey = encodeURIComponent(property);
    formBody.push("".concat(encodedKey, "=").concat(encodedValue));
  }

  formBody = formBody.join('&');
  return formBody;
};